<template>
    <div id="transfer-legal" v-if="coins.length" >
       <div class="title">{{$t('asset.transfer')}}</div>
       <ul class="coins">
           <li v-for="(coin,index) in coins" :key="index" :class="['pointer whites',{'active':index == coinIndex}]" @click="coinIndex = index;number = ''">
               {{coin}}
           </li>
       </ul>
       <div class="types">
           <div class="types-l">
               <div>{{$t('asset.from')}}</div>
               <div>{{$t('asset.to')}}</div>
           </div>
           <div class="types-r">
               <div>
                   <div>{{types[0]}}</div>
                   <div>{{types[1]}}</div>
               </div>
               <img src="../../../static/imgs/transfer1.png" alt="" @click="types.reverse();number=''">
           </div>
       </div>
       <div class="number">
           <input type="number" class="bdb input_color" :placeholder="$t('asset.pNum')" v-model="number">
           <span style="color:#61688a">{{coins[coinIndex].currency_name}}</span>
           <span class="all" @click="all">{{$t('td.all')}}</span>
       </div>
       <div class="balance" style="line-height:60px;margin:20px 0 0 0px" v-if="bibi!==null">{{$t('NEW.s19')}}：{{bibi.change_balance }}</div>
       <div class="balance" style="margin:5px 0 30px 0" v-if="licai!==null">{{$t('NEW.s20')}}：{{licai.usdt_balance}}</div>
       <button type='button' class="transfer" @click="transfer">{{$t('asset.transfer')}}</button>
    </div>
</template>

<script>
export default {
  data() {
    return {
      token: "",
      selectedCoin: { name: "", id: "" },
      change_coins:[],
      coins: ["USDT"],
      coinIndex: 0,
      types:[this.$t('NEW.s19'),this.$t('NEW.s20')],
      number:'',
      bibi:null,
      licai:null
    };
  },
  created() {
    this.getCoins();
  },
  mounted(){
      this.getPriceBi();
  },
  methods: {
      getPriceBi(){
        var that = this
        this.$http({
        url: " /api/wallet/detail",
        method:'post',
        headers: { Authorization: this.token },
        data:{
            type:"change",
            currency:3
        }
        // headers: { Authorization: that.token }
      })
        .then(res => {
            this.bibi= res.data.message
            console.log(res,1111)
        })
        .catch(error => {
          console.log(error);
        });


        this.$http({
        url: "/api/bank/my_account",
        method:'get',
        headers: { Authorization: this.token },
        // headers: { Authorization: that.token }
      })
        .then(res => {
            this.licai= res.data.message.account_info
        })
        .catch(error => {
          console.log(error);
        });


      },
    getCoins() {
      this.token = window.localStorage.getItem("token") || "";
      this.$http({
        url: "/api/wallet/list",
        method: "post",
        headers: { Authorization: this.token }
      }).then(res => {
        if (res.data.type == "ok") {
            // this.coins = res.data.message.legal_wallet.balance.filter(item=>item.is_legal==1);

            var data = res.data.message.change_wallet.balance;
            this.change_coins = data.filter(function(item,index) {
                // console.log(item)
                return item.is_legal==1;
            }); 
            console.log(this.change_coins)
        }
      });
    },
    all(){
       this.number = this.bibi.change_balance  
    },
    transfer(){
        var that = this
        console.log(that.number % 1)
        if(that.number % 1 !== 0){
            layer.msg(that.$t('NEW.s21'));
            return;
        }
        if(that.number == ''){
            layer.msg(that.$t('asset.pNum'));return;
        } else { 
            that.$http({
                url:'/api/bank/transaction',
                method:'post',
                data:{
                    amount:that.number
                },
                headers: { 'Authorization': that.token }
            }).then(res => {
                console.log(res)
               layer.msg(res.data.message)
                if(res.data.type == 'ok'){
                    console.log(this.coinIndex,this.coins[this.coinIndex]);
                    setTimeout(() => {
                        this.$router.push({path:'/conductFinancial'})
                    },2000)
                }
            })
        }
    }
  }
};
</script>

<style lang='scss' scoped>
#transfer-legal {
  padding: 0 30px;
  color: #c7cce6;
  > .title {
      padding: 20px 0;
    font-size: 24px;
    color: #61688a;
  }
  > .coins {
    display: flex;
    justify-content: center;
    li {
      margin-right: 20px;
      padding: 5px 20px;
    //   color: #fff;
      background: #234165;
    }
    .active {
      background: #7a98f7 !important;
      color: #fff !important;
    }
  }
  >.types{
      margin: 30px 0;
    //   width: 400px;
      height: 80px;
      display: flex;
      justify-content: space-between;
      line-height: 40px;
      .types-r{
          display: flex;
      }
      img{
          margin: 25px;
          width: 30px;
          height: 30px;
      }
  }
  .number{
      margin: 30px 0 0;
    //   width: 430px;
      line-height: 40px;
      input{
        // border:none;
        // color:#f2f5ff;
        background: none;
        line-height: 40px;
        width: 755px;
        // border-bottom: 2px solid #3a4975;

      }
      .all{
          margin-left: 10px;
          padding-left: 10px;
          border-left: 1px solid #ccc;
      }
  }
  .transfer{
      display: block;
      margin: 0 auto;
      line-height: 40px;
      width: 200px;
      background: #7a98f7;
      color: #fff;
      border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/accounts/transferLegal1.vue